import React, { createContext, useContext } from 'react';
import configData from '../config/three.json';

const ConfigContext = createContext(null);

/**
 * Fournit la configuration du parcours (three.json) et un accès centralisé.
 * Source de vérité unique pour les étapes, choix et prix.
 */
export function ConfigProvider({ children }) {
  const value = {
    config: configData,
    steps: configData?.steps ?? [],
    getStepByName: (name) => configData?.steps?.find((s) => s.name === name) ?? null,
  };

  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
}

export function useConfig() {
  const ctx = useContext(ConfigContext);
  if (!ctx) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return ctx;
}

export default ConfigContext;
